import React, { Component } from 'react';
import {  UpdateState, getState, getSession, AlertMessage, AlertMessageOut, clearSession } from "./function";
import ReactPaginate from 'react-paginate';
import { limit_per_page, name, ApiEndpoint, platform } from "../Constant";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { DateTime } from "../Components/function";
import * as axios from 'axios';

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

export const FingerPrint = async (type = 'visitor') => {
// Get the visitor identifier when you need it.
const fp = await fpPromise;
const result = await fp.get();

// This is the visitor identifier:
if(type === 'visitor'){
 return result.visitorId;
}
else{
  //return result.visitorId;
}
}

class DataTable extends Component{

    constructor(props){
      super(props);
      
      this.state = {
        page: 1,
        total_page: 1,
        total_result: 0,
        offset: '-1',
        offset_set: 0,
        limit: limit_per_page,
        data: [],
        message: '',
        loading: '',
        retry_times: 0,
      }
      }
  
      componentDidMount(){
       this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'));
      }
  
      componentDidUpdate(prevProps) {
       //this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'));
      }
     
      AlertNoTableData = (len) => {
        return <tr><td colspan={len}><div className='p15 center block'>No Table Data - No Result found!</div></td></tr>;
      }

      handlePageClick = (data) => {

        let selected = data.selected;
        let offset = Math.ceil((selected) * limit_per_page);
         UpdateState(this, 'offset', offset == 0 ? '-1' : offset);
         UpdateState(this, 'offset_set', offset);
         UpdateState(this, 'page', (selected + 1));
        this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'));
        };
      
      loadDataFromServer = async (cmd, offset, limit) => {
        
        UpdateState(this, 'loading', '1');

        let DeviceSid = await FingerPrint();

        let header = {
            headers : {
                'Accept': 'application/json',
                'Content-Type': "application/x-www-form-urlencoded",
                'Authorization': "Bearer " + getSession('token') + ", Session " + DeviceSid + ", Platform "+ platform,
                'My-Custom-Header': name,
                'User-Agent': name+ " Bot",
               }
         };

         let datas = new URLSearchParams({
            command: 'fetch',
            cmd: this.props.cmd,
            user_id: getSession('userID'),
            limit: getState(this, 'limit'),
            offset: getState(this, 'offset'),
            page: getState(this, 'page'),
        }).toString();
         
           axios.get(ApiEndpoint+"/fetchResult?"+datas, header)
           .then(response => {
           
            UpdateState(this, 'loading', '0');

           if(response.data.retry == true){
             let retryTimes = getState(this, 'retry_times') >= 0 && getState(this, 'retry_times') != '' ? getState(this, 'retry_times') : ''; 
             if(retryTimes != ''){
             if(getState(this, 'retry_times') < 15){
              setTimeout(function(){
             UpdateState(this, 'retry_times', getState(this, 'retry_times') + 1);
             this.loadDataFromServer(cmd, offset, limit);
              }, 4000);
             }
             }
           }
      
          if(response.data.error == false && response.data.error != true){
          //alert(JSON.stringify(response.data.data));
          UpdateState(this, 'data', response.data.data.length > 0 ? response.data.data : []);
          UpdateState(this, 'total_page', response.data.total_page);
          UpdateState(this, 'total_result', response.data.total_result);
          UpdateState(this, 'message', '');
          UpdateState(this, 'loading', '0');

          }
          else if(response.data.error != false){
            AlertMessage(this, response.data.error, 'error');
           UpdateState(this, 'loading', '0');
            if(response.data.logout == true && response.data.token == false){
              setTimeout(function(){
              clearSession();
              window.location.href = "/login";
              }, 4000);
              }
          }
          else{
             UpdateState(this, 'loading', '0');
            AlertMessage(this, "Something went wrong, try again or try to reload the page!", 'error');
          }
        }).catch(err => {
           UpdateState(this, 'loading', '0');
            AlertMessage(this, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
            this.loadDataFromServer(cmd, offset, limit);
        });
      }

setLoading = () => {
    UpdateState(this, 'loading', '1');

    let that = this;

    setTimeout(function(){
    UpdateState(that, 'loading', '0');
    }, 3200);
}

  render() {
    return ( 
        <>
    <div className="responsive-tables">

  {getState(this, 'loading') == '1' ?
   (<div className="table-loader">
  <div className="overlay">
    <div className="overlay__inner">
        <div className="overlay__content"><span className="spinner"></span></div>
    </div>
</div>
</div>) : ''}

    {AlertMessageOut(this)}

 <div className="responsive-table">
    <table>
        
 <thead><tr>
 <th>S/N</th>
     {this.props.th?.map((th, i) => {
      return <th className={this.props.thclassX[i]} key={i}>{th}</th>
     })}
 </tr>
 </thead>

 <tbody>
 {getState(this, 'data')?.length == 0 ? this.AlertNoTableData(this.props.th.length + 1) : ''}
 {getState(this, 'data')?.map((td, i) => {
    
   return(
     <tr key={i}>
     <td key={i}> {i+1} </td> 
     <td className="nowrap">{td['scriptID']}
     {td['resubmit'] && td['resubmit'] != "" 
        && td['resubmit'] !== undefined ? (<><br/><span>
        ---------------------------<br/>
        {td['resubmit']}
        </span></>) : (<></>)}</td>
     <td>{td['title']}</td>
     <td>
     <div className="nowrap chip-flex">
        <div className={td['status_badge']+ " spans"}>
        {td['status']}
        </div>
        {td['pay_status'] && td['pay_status'] != "" 
        && td['pay_status'] !== undefined && td['pay_status'] > 0 && td['payment'] != false && td['payment']['url'] != "" ? (
        <><button className="chip successX x0 open-payment-modal" data-payment-uri={td['payment']['url']} data-payment-place={this} onClick={() => this.setLoading()}>PAY NOW</button>
        </>) : (<></>)}
        </div>
        </td>
     <td className="nowrap">{td['added']}</td>
    </tr>);
     })}

     </tbody>

    <tfoot><tr>
    <th>S/N</th>
     {this.props.th?.map((th, i) => {
      return <th className={this.props.thclassX[i]} key={i}>{th}</th>
     })}
 </tr>
 </tfoot>

</table>
</div>

<div className="card-lt">  

<div>Page: {getState(this, 'page')} of {getState(this, 'total_page')} ⟺ ☆ Result: {parseInt(getState(this, 'offset_set')) + parseInt(1)} - {Math.ceil(getState(this, 'page') * limit_per_page) >= getState(this, 'total_result') ? getState(this, 'total_result') : Math.ceil(getState(this, 'page') * limit_per_page)} of {getState(this, 'total_result')}</div>

<ReactPaginate
          previousLabel={'« Prev'}
          nextLabel={'Next »'}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={getState(this, 'total_page')}
          marginPagesDisplayed={2}
          pageRangeDisplayed={4}
          onPageChange={this.handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
 </div>
</div>
</>
);
}
}

export default DataTable;